/* tslint:disable */
/* eslint-disable */
/**
 * Email API
 * API for managing email templates and sending documents via Brevo
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetDocumentTemplatePreviewCommand,
  GetTemplatePreviewCommand,
  OperationResponse,
  SendDocumentEmailCommand,
  TemplatePreviewResponse,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetDocumentTemplatePreviewCommandFromJSON,
    GetDocumentTemplatePreviewCommandToJSON,
    GetTemplatePreviewCommandFromJSON,
    GetTemplatePreviewCommandToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SendDocumentEmailCommandFromJSON,
    SendDocumentEmailCommandToJSON,
    TemplatePreviewResponseFromJSON,
    TemplatePreviewResponseToJSON,
} from '../models/index';

export interface GetDocumentTemplatePreviewRequest {
    getDocumentTemplatePreviewCommand: GetDocumentTemplatePreviewCommand;
}

export interface GetTemplatePreviewRequest {
    getTemplatePreviewCommand: GetTemplatePreviewCommand;
}

export interface SendDocumentEmailRequest {
    sendDocumentEmailCommand: SendDocumentEmailCommand;
}

/**
 * 
 */
export class EmailsApi extends runtime.BaseAPI {

    /**
     * Récupère un aperçu du template email de document avec les variables résolues. Génère automatiquement les paramètres (nom client, logo, couleurs) à partir du RisqueAssureId
     * Aperçu du template email de document
     */
    async getDocumentTemplatePreviewRaw(requestParameters: GetDocumentTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplatePreviewResponse>> {
        if (requestParameters['getDocumentTemplatePreviewCommand'] == null) {
            throw new runtime.RequiredError(
                'getDocumentTemplatePreviewCommand',
                'Required parameter "getDocumentTemplatePreviewCommand" was null or undefined when calling getDocumentTemplatePreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emails/documents/preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetDocumentTemplatePreviewCommandToJSON(requestParameters['getDocumentTemplatePreviewCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplatePreviewResponseFromJSON(jsonValue));
    }

    /**
     * Récupère un aperçu du template email de document avec les variables résolues. Génère automatiquement les paramètres (nom client, logo, couleurs) à partir du RisqueAssureId
     * Aperçu du template email de document
     */
    async getDocumentTemplatePreview(requestParameters: GetDocumentTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplatePreviewResponse> {
        const response = await this.getDocumentTemplatePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Récupère un aperçu du template Brevo avec les variables résolues
     * Récupère un aperçu du template Brevo
     */
    async getTemplatePreviewRaw(requestParameters: GetTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplatePreviewResponse>> {
        if (requestParameters['getTemplatePreviewCommand'] == null) {
            throw new runtime.RequiredError(
                'getTemplatePreviewCommand',
                'Required parameter "getTemplatePreviewCommand" was null or undefined when calling getTemplatePreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emails/templates/preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetTemplatePreviewCommandToJSON(requestParameters['getTemplatePreviewCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplatePreviewResponseFromJSON(jsonValue));
    }

    /**
     * Récupère un aperçu du template Brevo avec les variables résolues
     * Récupère un aperçu du template Brevo
     */
    async getTemplatePreview(requestParameters: GetTemplatePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplatePreviewResponse> {
        const response = await this.getTemplatePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Envoie un document par email via un template Brevo générique. Récupère automatiquement le logo et les couleurs de la plateforme du courtier
     * Envoie un document par email
     */
    async sendDocumentEmailRaw(requestParameters: SendDocumentEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['sendDocumentEmailCommand'] == null) {
            throw new runtime.RequiredError(
                'sendDocumentEmailCommand',
                'Required parameter "sendDocumentEmailCommand" was null or undefined when calling sendDocumentEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emails/documents/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendDocumentEmailCommandToJSON(requestParameters['sendDocumentEmailCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Envoie un document par email via un template Brevo générique. Récupère automatiquement le logo et les couleurs de la plateforme du courtier
     * Envoie un document par email
     */
    async sendDocumentEmail(requestParameters: SendDocumentEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.sendDocumentEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
